export type AccountSortField = "name" | "amount";
export type AccountSortDirection = "asc" | "desc";

export interface AccountSort {
  field: AccountSortField;
  direction: AccountSortDirection;
}

export interface AccountSortTarget {
  name: string;
  monthly_balance?: number | null;
}

export const compareAccounts = (
  a: AccountSortTarget,
  b: AccountSortTarget,
  field: AccountSortField,
  direction: AccountSortDirection,
) => {
  const multiplier = direction === "asc" ? 1 : -1;

  if (field === "name") {
    return a.name.localeCompare(b.name, undefined, { sensitivity: "base" }) * multiplier;
  }

  const balanceDelta = Number(a.monthly_balance ?? 0) - Number(b.monthly_balance ?? 0);
  return balanceDelta !== 0
    ? balanceDelta * multiplier
    : a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
};
